<div class="toast_banner"> <mat-icon svgIcon="information-circle"></mat-icon>
    <div id="toastbanner_panel_header"><adp-label [labelKey]="valueToDisplay"></adp-label></div>
</div>